import { useQueryParams } from '@/hooks';
import { GenderEnum } from '@/lib/enum';

const useUrlParams = () => {

  const { values: [gender], setValue } = useQueryParams(['gender'], { gender: GenderEnum.MALE });

  const changeGender = (newGender: GenderEnum) =>
    setValue('gender', newGender);

  return ({
    gender: gender as GenderEnum,
    changeGender
  });

};

export default useUrlParams;
